import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";

import "./chefIndividualScreen.css";
import "../HostScreen/hostScreen.css";

import { Modal, Tabs } from "antd";
import { Carousel } from "react-responsive-carousel";

import { useDispatch, useSelector } from "react-redux";

import { fetchChefMenu } from "../../store/menuActions";
import { menuActions } from "../../store/menuSlice";
import { PREP_TIME } from "../../store/constants";

import {
  getDisplayChefTimeLabel,
  getTodayDateValue,
  secondShiftApplies,
} from "../../utils/timeHelper";

import moment from "moment";
import classNames from "classnames";
import mixpanel from "mixpanel-browser";

import BottomBar from "../BottomBar";
import ChefCardComponent from "./ChefCardComponent";
import ChefMenuComponent from "./ChefMenuComponent";
import DineInComponent from "./DineInComponent";
import InstagramReelEmbed from "../explore/InstagramReelEmbed";

import HostScreen from "../HostScreen/Index";
import HostDetailsComponent from "../HostScreen/HostDetailsComponent";
import Experiences from "../HostScreen/Experiences";
import CuiratorProfile from "../HostScreen/CuiratorProfile";

import LeafIconSvg from "../../assets/ReactSvg/LeafIconSvg";
import BackFilledSvgIcon from "../../assets/ReactSvg/BackFilledSvgIcon";
import CallIconSvg from "../../assets/ReactSvg/CallIconSvg";
import WhatsappIconSvg from "../../assets/ReactSvg/WhatsappIconSvg";
import ClockIconSvg from "../../assets/ReactSvg/ClockIconSvg";

import useDetectKeyboardOpen from "use-detect-keyboard-open";

import { bottomBarActions } from "../../store/bottomBarSlice";
import { chefActions } from "../../store/chefSlice";
import { loginActions } from "../../store/loginSlice";
import { referActions } from "../../store/referSlice";

import { updateUser } from "../../store/loginActions";
import { fetchChefExperiences } from "../../store/chefActions";

import { toast, ToastContainer } from "react-toastify";
import ContentLoader from "react-content-loader";

import "react-responsive-carousel/lib/styles/carousel.min.css";


// const STATIC_HERO_QUOTE =
//   "Pizza Hut was her first memorable restaurant experience during college.";

const STATIC_PRICE_FOR_TWO = "₹300 for Two";


const ChefIndividualScreen = () => {
  const isKeyboardOpen = useDetectKeyboardOpen();
  const dispatch = useDispatch();
  const menuLoaded = useSelector((state) => state.menu.menuLoaded);
  const chefList = useSelector((state) => state.chef.chefList);
  const currentChefIdClicked = useSelector(
    (state) => state.menu.currentChefIdClicked
  );
  const chefInfoDefaultKey = useSelector(
    (state) => state.menu.chefInfoDefaultKey
  );

  const [showOpenValidation, setShowOpenValidation] = useState(false);
  const [showDishPriceValidation, setShowDishPriceValidation] = useState(false);
  const [action, setAction] = useState(() => { });
  const [button, setButton] = useState("");
  const [message, setMessage] = useState("");
  const [isMenuModalOpen, setIsMenuModalOpen] = useState(false);
  const currentChefInfo = chefList.find((c) => c._id === currentChefIdClicked);
  const { cartData, totalCost } = useSelector(({ cart }) => cart);
  const user = useSelector(({ auth }) => auth.user);
  const [categoriesdata, setCategoriesdata] = useState([]);
  const [visible, setVisible] = useState(false);
  const [showAddedItemPopup, setShowAddedItemPopup] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [isFirstMediaLoaded, setIsFirstMediaLoaded] = useState(false);

  const menuDetails = useSelector((state) => state.menu.menuDetails);
  const FREE_OPENS = user.maxDishes ? user.maxDishes : 2;
  const FREE_OPENS_AFTER_SIGNUP = user.maxChefs ? user.maxChefs : 4;
  const FREE_DISH_OPENS = user.maxDishPrices ? user.maxDishPrices : 10;
  const freeMenuOpens = useSelector((state) => state.auth.freeMenuOpens);
  const askToOpenWithoutSignup = !user.referral && freeMenuOpens < FREE_OPENS;
  const askForSignup = !user.referral && freeMenuOpens >= FREE_OPENS;

  const askToOpenWithSignup =
    user.referral && user.menuOpens < FREE_OPENS_AFTER_SIGNUP;
  const askForRefferal =
    user.referral && user.menuOpens >= FREE_OPENS_AFTER_SIGNUP;

  const askForSignupToCheckPrice = !user.referral;
  const askForRefferalToCheckPrice = false;
  const showFreeDishCheckPriceRemaining =
    user.referral && user.dishPriceChecked < FREE_DISH_OPENS;

  const deliveryDetails = useSelector(({ auth }) => auth.deliveryDetails);
  const isServiceable = useSelector((state) => state.auth.isServiceable);
  const kitchensList = useSelector((state) => state.chef.kitchensList);
  const kitchenInfo = kitchensList.find((k) => k._id === currentChefInfo.kitchenId);


  const { _id: chefId, name: chefName, profileImg, label1: chefLabel1, cardImage, title, cost, timings, cta, experienceType, expertStoryImages, expertStoryVideos } = currentChefInfo || {};
  const [viewExperiencePage, setViewExperiencePage] = useState(false);
  const hostList = useSelector((state) => state.host.hostList);
  const hostDetails = hostList[0];

  const {
    name,
    role = [],
    availability,
  } = hostDetails || {};

  const chefExperiences = useSelector(
    (state) => state.chef.chefExperiences[currentChefIdClicked] || []
  );

  const chefExperiencesMediaList = chefExperiences;
  const chefExperiencesGrid = chefExperiences.filter(
    (exp) => exp.mediaType !== "Carousel"
  );

  const chefExperiencesLoading = useSelector(
    (state) => state.chef.chefExperiencesLoading[currentChefIdClicked]
  );

  // const heroQuote =
  //   hostDetails?.quote ||
  //   (hostDetails?.bio ? hostDetails.bio.slice(0, 120) : null) ||
  //   STATIC_HERO_QUOTE;

  const getChefDistance = (chefInfo) => {
    const { kitchenId } = chefInfo || {};

    const chefDeliveryDetails = deliveryDetails[kitchenId] || {};
    const distance = Math.round(chefDeliveryDetails?.delivery_distance / 1000);

    return `${distance}km`;
  };

  const getChefDeliveryTime = (chefInfo) => {
    const { kitchenId, chefWaitTime } = chefInfo || {};

    const chefDeliveryDetails = deliveryDetails[kitchenId] || {};
    const delivery_duration = chefDeliveryDetails?.delivery_duration?.value;

    const deliveryTime = delivery_duration
      ? Math.round(delivery_duration / 60)
      : 0;

    const prepTime = Math.max(PREP_TIME, chefWaitTime || 0);

    return `${deliveryTime + prepTime}min`;
  };

  const getChefHours = (chefInfo) => {
    const { schedules = [] } = chefInfo || {};

    const todayChefSchedule = getTodayDateValue(schedules);

    const startTime = todayChefSchedule?.startTime;
    const endTime = todayChefSchedule?.endTime;

    return `${moment(startTime, "h:mm A").format("h a")} - ${moment(
      endTime,
      "h:mm A"
    ).format("h a")}`;
  };

  const distance = getChefDistance(currentChefInfo);
  const deliveryTime = getChefDeliveryTime(currentChefInfo);
  const hours = getChefHours(currentChefInfo);

  const onHostClick = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
  };

  const onChefClick = (chefId) => {
    dispatch(menuActions.setCurrentChefIdClicked(chefId));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
  };

  const onViewAllClick = () => {
    setViewExperiencePage(true);
  };


  const getStatusLabel = (chefInfo) => {
    const {
      isSwitchOff,
      chefWaitTime,
      showOnlyDot = false,
      schedules = [],
      kitchenId,
    } = chefInfo || {};
    const chefDeliveryDetails = deliveryDetails[kitchenId] || {};
    const delivery_duration = chefDeliveryDetails?.delivery_duration?.value;
    let delivery_Time = delivery_duration
      ? Math.round(delivery_duration / 60)
      : 10;

    const chefWaitTimeValue = Math.max(PREP_TIME, chefWaitTime || 0);
    const todayChefSchedule = getTodayDateValue(schedules);

    if (!isServiceable) {
      return "Pre-bookings only";
    } else if (isSwitchOff) {
      return "offline";
    } else if (!todayChefSchedule?.isAvailable) {
      const findNextDayIndex = schedules.findIndex(
        (s) => s._id === todayChefSchedule._id
      );
      if (findNextDayIndex === schedules.length - 1) {
        const nextDayInfo = schedules[0];
        const startTime = nextDayInfo?.startTime || nextDayInfo?.startTime1;
        return `Opens tomorrow at ${startTime}`;
      } else {
        const nextDayInfo = schedules[findNextDayIndex + 1];
        const startTime = nextDayInfo?.startTime || nextDayInfo?.startTime1;
        return `Opens tomorrow at ${startTime}`;
      }
    } else if (todayChefSchedule?.online) {
      if (delivery_duration) {
        return `Delivery in ${delivery_Time + chefWaitTimeValue} mins`;
      } else {
        return "Open now";
      }
    } else if (todayChefSchedule?.isAvailable) {
      if (
        secondShiftApplies(todayChefSchedule) &&
        todayChefSchedule?.startTime1 &&
        todayChefSchedule?.endTime1
      ) {
        return `Opens at ${moment(
          todayChefSchedule?.startTime1,
          "h:mm A"
        ).format("h a")}`;
      }
      return `Opens at ${moment(todayChefSchedule?.startTime, "h:mm A").format(
        "h a"
      )}`;
    }
  };

  const showSignUp = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "account" }));
    dispatch(bottomBarActions.updateFrom({ from: "cart" }));
    mixpanel.track("show-signup-clicked");
  };

  const showReferView = () => {
    dispatch(bottomBarActions.hideMenu());
    dispatch(referActions.onReferClick({ from: "chef" }));
    mixpanel.track("show-refer-clicked");
  };

  useEffect(() => {
    if (menuDetails?.categories) {
      setCategoriesdata(menuDetails?.categories);
    }
  }, [menuDetails?.categories]);

  const openMenu = () => {
    if (user.referral) {
      dispatch(updateUser(user, menuDetails._id, "menu"));
      setShowOpenValidation(false);
    } else {
      dispatch(loginActions.openFreeMenu(menuDetails._id));
      setShowOpenValidation(false);
    }
    mixpanel.track("open-menu-clicked");
    // clevertap.event.push("open-menu-clicked");
  };

  const validateDishPriceCheck = () => {
    if (askForSignupToCheckPrice) {
      setShowDishPriceValidation(false);
      formValidationMessage(false, true);
      return false;
    } else if (askForRefferalToCheckPrice) {
      setShowDishPriceValidation(true);
      formValidationMessage(false, true);
      return false;
    } else {
      setShowDishPriceValidation(false);
      return true;
    }
  };

  const formValidationMessage = (openValidation, priceValidation) => {
    if (openValidation || showOpenValidation) {
      if (askToOpenWithoutSignup) {
        let freeOpens = FREE_OPENS - freeMenuOpens;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? " chef" : " chefs";
        setMessage(
          "You can unlock " + menu + " of " + freeOpens + chef + " before login"
        );
        setAction(() => openMenu);
        setButton("Unlock Menu");
      } else if (askToOpenWithSignup) {
        let freeOpens = FREE_OPENS_AFTER_SIGNUP - user.menuOpens;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? "chef" : "chefs";
        setMessage(
          "You can unlock " + menu + " of " + freeOpens + " more " + chef
        );
        setAction(() => openMenu);
        setButton("Unlock Menu");
      } else if (askForSignup) {
        let freeOpens = FREE_OPENS_AFTER_SIGNUP - FREE_OPENS;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? "chef" : "chefs";
        setMessage(
          "You can unlock " +
          menu +
          " of " +
          freeOpens +
          " more " +
          chef +
          " on login"
        );
        setAction(() => showSignUp);
        setButton("Login");
      } else if (askForRefferal) {
        let freeOpens = FREE_OPENS_AFTER_SIGNUP;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? "chef" : "chefs";
        setMessage(
          "You can unlock " +
          menu +
          " of " +
          FREE_OPENS_AFTER_SIGNUP +
          " more " +
          chef +
          " on Referral"
        );
        setAction(() => showReferView);
        setButton("Refer");
      }
    } else if (priceValidation || showDishPriceValidation) {
      if (askForSignupToCheckPrice) {
        setMessage("Login to check current price of dishes");
        setAction(() => showSignUp);
        setButton("Login");
      } else if (askForRefferalToCheckPrice) {
        setMessage("Refer your friends to check more dish prices");
        setAction(() => showReferView);
        setButton("Refer");
      } else if (showFreeDishCheckPriceRemaining) {
        let freeOpens = FREE_DISH_OPENS - user.dishPriceChecked;
        let dish = (freeOpens = 1 ? "dish" : "dishes");
        setMessage(
          "Check current price of up to " +
          (FREE_DISH_OPENS - user.dishPriceChecked) +
          " " +
          dish
        );
        setAction(() => validateDishPriceCheck);
        setButton("Okay");
      }
    }
  };

  useEffect(() => {
    if (totalCost !== 0) {
      setShowAddedItemPopup(true);
      setShowOpenValidation(false);
      setShowDishPriceValidation(false);
    } else {
      setShowAddedItemPopup(false);
    }
  }, [totalCost]);

  const showCart = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "cart" }));
    dispatch(chefActions.onRedirect());
    mixpanel.track("menu-view-cart-clicked");
  };

  useEffect(() => {
    if (!visible) return;
    if (menuDetails?.chefId !== currentChefInfo?._id) {
      dispatch(fetchChefMenu(currentChefInfo?._id));
    }
  }, [visible]);

  const handleBookTableClick = () => {
    toast.error("Can’t book a table as we’re in beta");
  }

  const handleMenuClick = () => {
    dispatch(menuActions.setIsMenuClicked(true));
    dispatch(bottomBarActions.loadTab({ tabName: "menu" }));
    dispatch(chefActions.onMenuClick(chefId));
    // dispatch(bottomBarActions.updateFrom({ from: "dishesScreen" }));
    dispatch(chefActions.onMenuCategorieId(chefId));
    // mixpanel.track("go-to-menu-clicked");
    // clevertap.event.push("go-to-menu-clicked");
  };

  const totalPortions = cartData.reduce((acc, cartItem) => {
    return acc + cartItem.portion;
  }, 0);

  const todayChefSchedule = getTodayDateValue(currentChefInfo?.schedules);

  const textOutput = getDisplayChefTimeLabel(todayChefSchedule);

  const onCheckPrice = async (dishID, setShowAdd) => {
    // if (validateDishPriceCheck()) {
    //   dispatch(updateDishCheckedInUser(user, dishID));
    //   setShowAdd(true);
    // }
    //call pricing api to get current price
  };

  const openWhatsApp = (phoneNumber) => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const url = `https://wa.me/${phoneNumber}`;

    if (isIOS) {
      // iOS: window.open is unreliable for wa.me; use direct navigation instead
      window.location.href = url;
    } else {
      // Android/desktop: window.open works fine
      window.open(url, "_blank");
    }
  };

  const onChange = (key) => {
    setActiveTab(key)
  };


  const tabsItems = [
    {
      key: 1,
      label: "Menu",
      forceRender: true,
      children: (
        <ChefMenuComponent
          menuLoaded={menuLoaded}
          categoriesdata={categoriesdata}
          onCheckPrice={onCheckPrice}
          setShowAddedItemPopup={setShowAddedItemPopup}
        />
      ),
    },
    {
      key: 2,
      label: "About chef",
      forceRender: true,
      children: (
        <div>
          <div className="aboutChefInfoWrapperDescription">
            <div style={{ marginBottom: 50 }} className="aboutChefMainLabelWrapper">
              <div className="aboutChefMainLabel Satoshi">
                Story
              </div>
              <div style={{ marginBottom: 20 }} className="aboutChefInfoWrapperDescriptionWrapper">
                <ul className="aboutChefInfoWrapperDescriptionLabelList">
                  <li className="aboutChefInfoWrapperDescriptionLabel Satoshi">
                    {`${currentChefInfo?.label1}`}
                  </li>
                  {currentChefInfo?.label2 && <li className="aboutChefInfoWrapperDescriptionLabel Satoshi">
                    {`${currentChefInfo?.label2}`}
                  </li>}
                  {currentChefInfo?.label3 && <li className="aboutChefInfoWrapperDescriptionLabel Satoshi">
                    {`${currentChefInfo?.label3}`}
                  </li>}
                </ul>
              </div>
              <InstagramReelEmbed url={"https://www.instagram.com/reel/DLppTQry8hI/"} />
              <InstagramReelEmbed url={"https://www.instagram.com/p/DHYjNcYIjhx/"} />
            </div>
            {/* <div className="aboutChefMainLabelWrapper">
              <div className="aboutChefMainLabel Satoshi">Chef’s journey</div>
              <div className="aboutChefJourneyWrapper Satoshi">-</div>
            </div> */}
          </div>
        </div>
      ),
    },
    {
      key: 3,
      label: "Dine in",
      forceRender: true,
      children: (
        <DineInComponent currentChefInfo={currentChefInfo} />
      ),
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 10);

    // Clear the timeout if the component unmounts before 1 second
    return () => clearTimeout(timer);
  }, []);

  const handleFirstMediaLoad = () => {
    setIsFirstMediaLoaded(true);
  };

  useEffect(() => {
    if (currentChefIdClicked) {
      dispatch(fetchChefExperiences(currentChefIdClicked));
    }
  }, [currentChefIdClicked, dispatch]);

  const callChildFunction = (category) => {
    dispatch(bottomBarActions.updateFrom({ from: "menupopup" }));
    dispatch(chefActions.onMenuCategorieId(category._id));
  };
  // TODO: isRoundedDesign

  return (
    <>
      {!viewExperiencePage ? (
        <div className="hostExpertProfileScreen">
          <div className="hostExpertProfileScroll">
            <div className="hostExpertHero">
              <button
                type="button"
                onClick={onHostClick}
                className="hostTopBackbtn"
                aria-label="Back"
              >
                <BackFilledSvgIcon size={20} />
              </button>

              {!isFirstMediaLoaded && <div className="carousel-skeleton-overlay">
                <ContentLoader
                  viewBox="0 0 400 410"
                  height={"100%"}
                  width="100%"
                  backgroundColor="#f0f0f0"
                  foregroundColor="#e0e0e0"
                >
                  <rect x="0" y="0" rx={16} ry={16} width="400" height="410" />
                </ContentLoader>
              </div>}
              <div className={`chefIndividualCarouselWrapper ${isFirstMediaLoaded ? "show" : "hide"}`} >
                <Carousel
                  preventMovementUntilSwipeScrollTolerance
                  showArrows={false}
                  showThumbs={false}
                  showStatus={false}
                  showIndicators
                  swipeScrollTolerance={30}
                  className={classNames(
                    "slider-custom-carousel",
                    "hostExpertHeroCarousel"
                  )}
                  destroyCarousel
                >
                  {expertStoryImages.map((image, index) => (
                    <div key={index}>
                      <img
                        className="hostExpertHeroImage"
                        src={image}
                        alt=""
                        onLoad={index === 0 ? handleFirstMediaLoad : undefined}
                      />

                      {/* <div className="hostExpertQuoteCard">
                      <p className="hostExpertQuoteText Satoshi">{headline}</p>
                    </div> */}

                    </div>
                  ))}
                </Carousel>
              </div>
              {/* <div className="hostExpertHeroGradient" /> */}


            </div>

            <div className="hostExpertProfileCard">
              <div className="hostExpertProfileHeader">
                <img
                  className="hostExpertAvatar"
                  src={profileImg}
                  alt={chefName}
                />
                <div className="hostExpertProfileText">
                  <div className="hostExpertName Satoshi">{chefName}</div>
                  <div className="hostExpertRole Satoshi">{title}</div>
                </div>
              </div>

              <div className="hostExpertMetaBlock">
                <div className="hostExpertMetaRow Satoshi">
                  <span>{distance}</span>
                  <span className="hostExpertMetaDot" />
                  <span>{deliveryTime}</span>
                </div>
                <div className="hostExpertMetaRow Satoshi">
                  <span>{cost}</span>
                  <span className="hostExpertMetaDot" />
                  <span className="hostExpertMetaWithIcon">
                    <ClockIconSvg width={16} height={16} />
                    {timings}
                  </span>
                </div>
              </div>

              <div className="hostExpertContactRow">
                {cta.map((item, index) => {
                  let icon;
                  let label;

                  switch (item.type) {
                    case "Call":
                      icon = <CallIconSvg width={20} height={20} />;
                      label = "Call Us";
                      break;
                    case "WhatsApp":
                      icon = <WhatsappIconSvg size={20} />;
                      label = "WhatsApp";
                      break;
                    default:
                      icon = null;
                      label = item.type;
                  }

                  return (
                    <React.Fragment key={item.type}>
                      <button
                        type="button"
                        className="hostExpertContactBtn Satoshi"
                        onClick={() => {
                          if (item.type === "Call") {
                            window.open(`tel:${item.value}`, '_system');
                          } else if (item.type === "WhatsApp") {
                            openWhatsApp(item.value)
                          }
                        }}
                      >
                        {icon}
                        {label}
                      </button>
                      {index < cta.length - 1 && <span className="hostExpertMetaDot" />}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>

            <HostDetailsComponent
              hostDetails={hostDetails}
              chefName={chefName}
              chefLabel1={chefLabel1}
              expertStoryVideos={expertStoryVideos}
              distance={distance}
              kitchenInfo={kitchenInfo}
              onChefClick={onChefClick}
              onViewAllClick={onViewAllClick}
              experienceType={experienceType}
              hostExperience={chefExperiencesGrid}
              chefId={chefId}
            />
          </div>

          <div className="hostExpertBottomBar">
            <button onClick={handleMenuClick} type="button" className="hostExpertBookBtn Satoshi">
              View Menu
            </button>
          </div>

          <ToastContainer />
          <BottomBar isExplore />
        </div>
      ) : (
        <Experiences
          hostExperience={chefExperiencesMediaList}
          setViewExperiencePage={setViewExperiencePage}
        />
      )}
    </>
  );

  // return (
  //   <div className="chef-individual-screen-wrapper">
  //     <div className={`chef-individual-screen ${visible ? "open" : ""}`}>
  //       <div onElementRendered className="chefImageWrapper">
  //         <ChefCardComponent chef={currentChefInfo} isChefMainScreen={true} />
  //         <Tabs
  //           className="chefInfoTabs"
  //           defaultActiveKey={1}
  //           items={tabsItems}
  //           onChange={onChange}
  //         />
  //         {activeTab === 1 && <div className="chefMenuStickyBtnWrapper">
  //           <div
  //             onClick={() => setIsMenuModalOpen(true)}
  //             className="chefMenuStickyBtn"
  //           >
  //             <span className="chefMenuStickyBtnContent Satoshi">Menu</span>
  //           </div>
  //         </div>}
  //         <Modal
  //           title=""
  //           open={isMenuModalOpen}
  //           onCancel={() => setIsMenuModalOpen(false)}
  //           className="menuStickyPopupModal"
  //           wrapClassName="menuStickyPopupModalWrapClassName"
  //           width={244}
  //         >
  //           <div className="menuStickyPopupContainer">
  //             {categoriesdata.map((category) => (
  //               <div
  //                 onClick={() => {
  //                   callChildFunction(category);
  //                   setIsMenuModalOpen(false);
  //                 }}
  //                 key={category._id}
  //                 className="menuStickyPopupWrapper"
  //               >
  //                 <div className="menuStickyLabel Satoshi">{category.name}</div>
  //                 <div className="menuStickyLabelValue Satoshi">
  //                   {category?.dishes?.length}
  //                 </div>
  //               </div>
  //             ))}
  //           </div>
  //         </Modal>
  //       </div>
  //     </div>

  //     {!isKeyboardOpen && (
  //       <div
  //         className={
  //           showOpenValidation || showDishPriceValidation || showAddedItemPopup
  //             ? "browser-snackbar active"
  //             : "browser-snackbar deactive"
  //         }
  //         id="cart_option"
  //       >
  //         <div
  //           onClick={
  //             !showOpenValidation &&
  //             !showDishPriceValidation &&
  //             showAddedItemPopup
  //               ? showCart
  //               : action
  //           }
  //           className="browser-snackbar-detail"
  //         >
  //           <ul className="footer-list">
  //             <li className="list-item-options">
  //               <a href="#" className="menu-link">
  //                 {!showOpenValidation &&
  //                   !showDishPriceValidation &&
  //                   showAddedItemPopup && (
  //                     <div className="total-price-container">
  //                       <span style={{ margin: 0 }}>
  //                         {totalPortions}{" "}
  //                         {totalPortions == 1 ? "Item" : "Items"} Added
  //                       </span>

  //                       <span onClick={showCart}>
  //                         View Cart
  //                         <img
  //                           src="images/icon-view-cart.svg"
  //                           alt="view-cart"
  //                           loading="lazy"
  //                         />
  //                       </span>
  //                     </div>
  //                   )}
  //                 {(showOpenValidation || showDishPriceValidation) && (
  //                   <span>{button}</span>
  //                 )}
  //               </a>
  //             </li>
  //             {(showOpenValidation || showDishPriceValidation) && (
  //               <li className="list-item-description">
  //                 <div className="total-items">
  //                   <a href="#" className="cart-items">
  //                     <span>{message}</span>
  //                   </a>
  //                 </div>
  //               </li>
  //             )}
  //           </ul>
  //         </div>
  //       </div>
  //     )}
  //     <ToastContainer />
  //     <BottomBar isExplore />
  //   </div>
  // );
};

export default ChefIndividualScreen;
